import { render, staticRenderFns } from "./NotebookOfSupervisors.vue?vue&type=template&id=178c6162"
import script from "./NotebookOfSupervisors.vue?vue&type=script&lang=js"
export * from "./NotebookOfSupervisors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports